<template>
    <div class="">
        <div class="px-4 sm:px-0">
            <h3 class="font-medium text-iron-700 tracking-[-0.01em]">
                <slot name="title"></slot>
            </h3>

            <p class="mt-1 text-sm text-iron-500 tracking-[-0.01em]">
                <slot name="description"></slot>
            </p>
        </div>
    </div>
</template>
